import type { $Fetch } from 'ofetch';
import type { AcademicoDashboard } from '@/domain/model/AcademicoDashboard';
import type { AcademicoDashboardGateway } from '@/application/port/out/AcademicoDashboardGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpAcademicoDashboardGateway implements AcademicoDashboardGateway {
  constructor(private readonly client: $Fetch) {}

  async fetch(): Promise<AcademicoDashboard> {
    const res = await this.client<ApiResponse<AcademicoDashboard>>('/api/v1/acadadmin/dashboard', {
      method: 'GET',
    });
    assertApiSuccess(res);
    return res.data;
  }
}
